<template>
  <div>
    <DesktopTechnologyService v-if="!isMobile" />
    <MobileTechnologyService v-if="isMobile" />

  </div>
</template>

<script>
import DesktopTechnologyService from '@/components/corporate/technology-service/desktop/TechnologyService'
import MobileTechnologyService from '@/components/corporate/technology-service/mobile/TechnologyService'
export default {
  components: {
    DesktopTechnologyService,
    MobileTechnologyService
  },
  metaInfo() {
      return {
        title: this.$route.meta.title,
        meta: [
          { name: "description", content: this.$route.meta.description},
          {
            vmid: 'robots',
            name: 'robots',
            content: 'index, follow'
          }
        ],
      };
    },
  data() {
    return {
      isMobile: false
    }
  },
  methods: {
    handleView() {
      this.isMobile = window.innerWidth <= 990
    }
  },
  mounted() {
    this.$gtag.pageview(this.$route);
    this.$utils.scrollTop()
  },
  beforeMount() {
    this.handleView();
  }
}
</script>